/**
 * Category Bento Premium — sprite animation on hover (CDN / Files frames).
 */
(function () {
  const padFrame = (num, padLength) => String(num).padStart(padLength, '0');

  const getQuerySuffix = (url) => {
    const q = url.indexOf('?');
    return q >= 0 ? url.slice(q) : '';
  };

  const getPath = (url) => url.split('?')[0];

  const buildFrameUrl = (media, img, frameNum, padLength) => {
    const first = media.dataset.spriteFirst || img.currentSrc || img.src || '';
    const query = getQuerySuffix(first);
    const path = getPath(first);

    if (/\d{4}/.test(path)) {
      return path.replace(/\d{4}(?=\.[^./?]+$)/, padFrame(frameNum, padLength)) + query;
    }

    const base = (media.dataset.spriteBase || '').trim();
    const prefix = media.dataset.spritePrefix || '';
    const ext = (media.dataset.spriteExt || 'png').replace(/^\./, '');
    return `${base}${prefix}${padFrame(frameNum, padLength)}.${ext}${query}`;
  };

  const bindSpriteCard = (card) => {
    if (card.dataset.bentoSpriteInit === '1') return;

    const media = card.querySelector('[data-sprite-media]');
    if (!media) return;

    const img = media.querySelector('[data-sprite-image]');
    if (!img) return;

    const totalFrames = parseInt(media.dataset.spriteFrames, 10) || 16;
    const fps = parseInt(media.dataset.spriteFps, 10) || 12;
    const padLength = parseInt(media.dataset.spritePad, 10) || 4;
    let intervalId = null;
    let preloaded = false;
    let isPlaying = false;

    const stopSprite = () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      isPlaying = false;
    };

    const resetSprite = () => {
      stopSprite();
      const first = media.dataset.spriteFirst || img.src;
      if (first) img.src = first;
    };

    const preloadFrames = () => {
      if (preloaded) return;
      preloaded = true;
      for (let i = 1; i <= totalFrames; i += 1) {
        const preloader = new Image();
        preloader.src = buildFrameUrl(media, img, i, padLength);
      }
    };

    const startSprite = () => {
      if (isPlaying) return;
      isPlaying = true;
      stopSprite();
      isPlaying = true;
      preloadFrames();

      let frameNumber = 1;
      let direction = 1;
      img.src = buildFrameUrl(media, img, frameNumber, padLength);

      intervalId = setInterval(() => {
        const nextFrame = frameNumber + direction;

        if (nextFrame > totalFrames || nextFrame < 1) {
          direction *= -1;
          frameNumber += direction;
        } else {
          frameNumber = nextFrame;
        }

        img.src = buildFrameUrl(media, img, frameNumber, padLength);
      }, 1000 / fps);
    };

    const onEnter = () => startSprite();
    const onLeave = () => resetSprite();

    card.addEventListener('mouseenter', onEnter);
    card.addEventListener('mouseleave', onLeave);
    card.addEventListener('focusin', onEnter);
    card.addEventListener('focusout', onLeave);
    card.addEventListener('pointerenter', onEnter);
    card.addEventListener('pointerleave', onLeave);

    media.addEventListener('mouseenter', onEnter);
    media.addEventListener('mouseleave', onLeave);
    img.addEventListener('mouseenter', onEnter);

    card.addEventListener('touchstart', onEnter, { passive: true });

    card.dataset.bentoSpriteInit = '1';
  };

  const initBentoSprites = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-bento-sprite-section]').forEach((section) => {
      section.querySelectorAll('.premium-category-bento__card').forEach((card) => {
        bindSpriteCard(card);
      });
    });
  };

  const onSectionLoad = (event) => {
    const target = event.target;
    if (target && target.matches && target.matches('[data-bento-sprite-section]')) {
      initBentoSprites(target);
      return;
    }
    if (target && target.querySelector) {
      const nested = target.querySelector('[data-bento-sprite-section]');
      if (nested) initBentoSprites(nested);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBentoSprites(document));
  } else {
    initBentoSprites(document);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
})();
